import {
    GET_HOURLY_FORECAST_BY_LATLON_V5,
    GET_ZERO_HOUR_FORECAST_V5,
    GET_FULL_HOURLY_FORECAST_V5
} from '../actions/hourlyForecastActionsV5';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    hourlyForecastIsRefreshing: false,
    zeroHourForecastIsRefreshing: false,
    fullHourlyForecastIsRefreshing: false
};

const mergeFullHourlyForecast = (fullHourlyForecast) => {
    if (!fullHourlyForecast || !Array.isArray(fullHourlyForecast)) {
        return [];
    }
    const latestValue = {};
    fullHourlyForecast.forEach((partData) => {
        partData?.hf?.hfp.forEach((value) => {
            if(partData?.hf?.fcdtutc) {
                const newValue = {
                    ...value,
                    fcdtutc: new Date(partData.hf.fcdtutc)
                };
                const existing = latestValue[newValue.fdtolcl];
                if (!existing?.fcdtutc || existing.fcdtutc.getTime() < newValue.fcdtutc.getTime()) {
                    latestValue[newValue.fdtolcl] = newValue;
                }
            }
        });
    });
    return Object.values(latestValue);
};

export function hourlyForecastV5(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_HOURLY_FORECAST_BY_LATLON_V5.pending:
        {
            return {
                ...state,
                hourlyForecastIsRefreshing: true
            };
        }
    
        case GET_HOURLY_FORECAST_BY_LATLON_V5.fulfilled:
        {
            return {
                ...state,
                hourly: action.payload,
                lastError: undefined,
                hourlyForecastIsRefreshing: false
            };
        }
    
        case GET_HOURLY_FORECAST_BY_LATLON_V5.rejected:
        {
            return {
                ...state,
                hourly: undefined,
                lastError: action.payload,
                hourlyForecastIsRefreshing: false
            };
        }
        
        case GET_ZERO_HOUR_FORECAST_V5.pending:
        {
            return {
                ...state,
                zeroHourForecastIsRefreshing: true
            };
        }

        case GET_ZERO_HOUR_FORECAST_V5.fulfilled:
        {
            return {
                ...state,
                zeroHourData: action.payload,
                zeroHourLastError: undefined,
                zeroHourForecastIsRefreshing: false
            };
        }

        case GET_ZERO_HOUR_FORECAST_V5.rejected:
        {
            return {
                ...state,
                zeroHourData: undefined,
                zeroHourLastError: action.payload,
                zeroHourForecastIsRefreshing: false
            };
        }

        case GET_FULL_HOURLY_FORECAST_V5.pending:
        {
            return {
                ...state,
                fullHourlyForecastIsRefreshing: true
            };
        }

        case GET_FULL_HOURLY_FORECAST_V5.fulfilled:
        {
            return {
                ...state,
                fullHourlyData: mergeFullHourlyForecast(action.payload),
                fullHourlyLastError: undefined,
                fullHourlyForecastIsRefreshing: false
            };
        }

        case GET_FULL_HOURLY_FORECAST_V5.rejected:
        {
            return {
                ...state,
                fullHourlyData: undefined,
                fullHourlyLastError: action.payload,
                fullHourlyForecastIsRefreshing: false
            };
        }
    }

    return state;
}
